/**
 * 무결성 점검 (계획서 §17-7): 모든 레코드를 복호화·스키마 검증한다.
 * 손상이 발견되면 보고만 한다. 복구(history 사용)는 사용자 확인 후 Repository.recoverFromHistory로.
 */
import type { CounselDb } from './db/schema';
import type { Repository } from './repo/repository';

export type IntegrityReport = {
  checked: number;
  corrupted: { entityType: string; id: string; revision: number; reason: string }[];
  blobsChecked: number;
};

export async function verifyAll(db: CounselDb, repo: Repository): Promise<IntegrityReport> {
  const rows = await db.entities.toArray();
  const corrupted: IntegrityReport['corrupted'] = [];
  for (const r of rows) {
    try {
      await repo.decryptRecord(r);
    } catch (e) {
      corrupted.push({ entityType: r.entityType, id: r.id, revision: r.revision, reason: (e as Error).name });
    }
  }
  return { checked: rows.length, corrupted, blobsChecked: 0 };
}
